import React from 'react';
import ModalDialog from '../../../components/organisms/ModalDialog/ModalDialog';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AdditionalPrivilegeConfigEditForm } from '../forms/AdditionalPrivilegeConfigEditForm';

export function AdditionalPrivilegeCreateEditModal({ closeModal, form }: any) {
  const { t } = useSonTranslation('PrivilegeConfig');

  return (
    <ModalDialog closeModal={closeModal} headline={t('addAdditionalPrivilege')} initialFocusIndex={1}>
      <AdditionalPrivilegeConfigEditForm form={form} />
    </ModalDialog>
  );
}
